<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addPromoConfig.isOpen"
    id="add-promotion"
  >
    <div class="flex items-center justify-between px-6">
      <h4 class="text-2xl font-bold pb-2">Add New Promotion</h4>
      <feather-icon icon="XIcon" @click.stop="closeAddPromo" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
    <div class="sidebar-content p-6 scroll">
      <div class="info-form"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-delay="10"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
      data-aos-anchor-placement="top-center"
      >
          <h4 class="text-lg font-bold pb-3 mt-4">What to offer?</h4>
          <p>To be Redeemed at Check Out!</p>
          <div class="centerx labelx">
            <vs-input :maxlength="30" v-validate="'required'" name="promotion_name" v-model="promotion_name" class="w-full" :danger="errors.has('promotion_name')"
              danger-text="The promotion name field is required"/>
          </div>
          <h4 class="text-lg font-bold pb-3 mt-4">How much to offer?</h4>
          <div class="w-row">
            <ul class="centerx flex align-center justify-between">
              <vs-input-number min="0" :max="max" v-model="promotion_logic_value" class="w-7/12" :key="test"/>
                <!-- <li @click="max=100,test++"> -->
                <li @click="changType">
                  <vs-radio v-model="promotion_logic_type" vs-value="percent">%</vs-radio>
                </li>
                <li @click="max=999,test++" class="mr-base">
                  <vs-radio v-model="promotion_logic_type" vs-value="usd">$</vs-radio>
                </li>
            </ul>
          </div>
          <h4 class="text-lg font-bold mt-4">Who to offer?</h4>
          <ul class="centerx vx-row">
            <li v-for="(gr,index) in groupsList" :key="index" class="vx-col w-1/3">
              <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                <input class="vs-checkbox--input" v-validate:checkBox="'required'" name="checkBox" :danger="errors.has('checkBox')"
              danger-text="The group field is required" type="checkbox" v-model="checkBox" :id="gr.id" :value="gr.id" :click="check(gr)">
                <span class="checkbox_x vs-checkbox" :class="{'invalid-border': errors.has('checkBox') && abc}">
                  <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
                <span class="con-slot-label group-name">{{gr.name}}</span>
                <!-- <span>{{gr.name}}</span> -->
              </div>
            </li>
          </ul>
          <!-- <span class="text-danger text-xs error-text-input" v-show="errors.has('checkBox')">{{ errors.first('checkBox') }}</span>  -->
          <span class="text-danger text-xs error-text-input hide-error" :class="{'show-error': errors.has('checkBox') && abc}">{{ errors.first('checkBox') }}</span>
          <h4 class="text-lg font-bold pb-1">What is your Email title?</h4>
          <p class="pb-2">This will be seen by your customers on their email!</p>
          <vs-input :maxlength="40" v-validate="'required'" name="email_subject" v-model="email_subject" class="w-full" :danger="errors.has('email_subject')"
              danger-text="The business name field is required"/>
          <h4 class="text-lg font-bold pb-1">Business Name</h4>
          <vs-input :maxlength="40" v-validate="'required'" name="business_name" @input="inputBusinessName" v-model="business_name" :value="this.userInfo.name" class="w-full" :danger="errors.has('business_name')"
              danger-text="The business name field is required"/>
              <vs-checkbox class="mr-2" v-model="save_business_name">Save this business name for next time</vs-checkbox>
          <h4 class="text-lg font-bold pb-3">Offer Description</h4>
          <p class="pb-2">Don't forget to input your phone number in the message.</p>
          <vs-textarea :maxlength="text_area_length" v-model="offer_description" :counter="text_area_length" :counter-danger.sync="counterDanger" height="150" @input="inputDescription"/>
          <!-- <vs-input disabled class="w-full" value="Reply STOP to opt out."></vs-input> -->
          <!-- <p>This sentence is required by message provider and this keeps you safe from any lawsuit related to spam messages.</p> -->
          <!-- <vs-checkbox class="mr-2" v-model="exp_active">Exp: xx/xx/xx</vs-checkbox> -->
            <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                <input type="checkbox" class="vs-checkbox--input" :disabled="this.addPromoConfig.requireOptOut"  v-model="opt_out_active" @input="inputOptOut" :id="test" :key="Math.floor(Math.random() * 100)">
                <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                    <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
                <span class="con-slot-label">
                    <div class="title pl-4">Reply STOP to opt out.</div>
                </span>
            </div>
            <span v-if="this.addPromoConfig.requireOptOut">You have removed this message for 3 continuous promotion campaign, so it's required this time in order to avoid any issues of spam and unsolicited messages. You may remove this next time</span>

          <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                <input type="checkbox" class="vs-checkbox--input" v-model="exp_active" @input="inputExpired" :id="test" :key="Math.floor(Math.random() * 100)">
                <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
                    <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
                </span>
                <span class="con-slot-label">
                    <div class="title pl-4">Exp: xx/xx/xx</div>
                </span>
            </div>
          <h4 v-if="config.email_attach && config.email_attach == 1" class="text-lg font-bold">Your Email attached file?</h4>
          <input v-if="config.email_attach && config.email_attach == 1" type="file" @change="validateFile" ref="myFiles" class="w-full mb-6">
          <h4 class="text-lg font-bold">How long to offer?</h4>
          <div class="w-row">
             <div vs-w="12">
              <span class="flex align-center">
                <span class="mr-6">From</span>
                <!-- <flat-pickr class="w-full" :config="configdateTimePicker" v-model="pro_start_date" v-validate="'required'" name="pro_start_date" :class="{'invalid-border': errors.has('pro_start_date')}"/> -->
                <datepicker class="w-full" :disabledDates="disabledDates" :config="configdateTimePicker" v-model="pro_start_date" v-validate="'required'" name="pro_start_date" :class="{'invalid-border': errors.has('pro_start_date')}"></datepicker>
              </span>
              <span class="text-danger text-xs error-text-input hide-error ml-base pl-base" :class="{'show-error': errors.has('pro_start_date')}">The start date field is required</span>
             </div>
              <div vs-w="12">
                <span class="flex align-center">
                  <span style="margin-right: 40px;">To</span>
                  <!-- <flat-pickr class="w-full" :config="configdateTimePicker" v-model="pro_expired_date" v-validate="'required'" name="pro_expired_date" :class="{'invalid-border': errors.has('pro_expired_date')}"/> -->
                  <datepicker class="w-full" :disabledDates="disabledDates" :config="configdateTimePicker" v-model="pro_expired_date" v-validate="'required'" name="pro_expired_date" :class="{'invalid-border': errors.has('pro_expired_date')}"></datepicker>
                </span>
                <span class="text-danger text-xs error-text-input hide-error ml-base pl-base" :class="{'show-error': errors.has('pro_expired_date')}">The expired date field is required</span>
              </div>
          </div>

          <h4 class="text-lg font-bold mt-6">Would you like to test first? (strongly recommended)</h4>
          <div class="flex align-end mt-2">
             <div class="w-3/4 sm:w-2/3">
                 <span class="small">Enter phone number to receive a test</span>
                 <vs-input :maxlength="14" v-mask="'(###) ###-####'" type="tel" name="phone_test" v-model="phone_test" class="w-full" v-on:keypress="isNumber($event)"></vs-input>
             </div>
             <div class="w-1/4 sm:w-1/3 pl-6">
                 <vs-button @click="sendTest('sms')" class="w-full mt-8 px-3">Test Now</vs-button>
             </div>
          </div>
           <div class="flex align-end mt-2">
             <div class="w-3/4 sm:w-2/3">
                 <span class="small">Enter email to receive a test</span>
                 <vs-input name="email_test" v-model="email_test" class="w-full"></vs-input>
             </div>
             <div class="w-1/4 sm:w-1/3 pl-6">
                 <vs-button @click="sendTest('email')" class="w-full mt-8 px-3">Test Now</vs-button>
             </div>
          </div>

          <h4 class="text-lg font-bold w-full d-inline-block mt-4">One time use only</h4>
            <div class="flex align-center">
              <vs-checkbox class="mr-2" v-model="has_promotion" vs-value="1">Promotion for one time use only</vs-checkbox>
            </div>
          <h4 class="text-lg font-bold">When to send offer?</h4>
           <ul class="mb-6">
             <li>
                <vs-radio v-model="type_submit" vs-value="2">Scheduled by</vs-radio>
              </li>
              <div v-show="type_submit === '2'">
                <!-- <datepicker :disabledDates="disabledDates" :config="configdateTimePicker" v-model="pro_scheduler_date" class="input-schedule"></datepicker> -->
                <flat-pickr :config="configdateTimePicker" v-model="pro_scheduler_date" class="input-schedule" />
              </div>
              <div v-show="type_submit === '1'"></div>
              <li>
                <vs-radio v-model="type_submit" vs-value="1">Immediately</vs-radio>
              </li>
           </ul>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="addPromotion" style="min-width: 140px;">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeAddPromo" style="min-width: 140px;">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
// import { StringHelper } from "../../models/string_helper";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
// import VeeValidate from 'vee-validate';

export default {
  name: "vs-add-promotion",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    flatPickr,
    VuePerfectScrollbar,
    Datepicker
  },
  props: {
    addPromoConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    },
    groupsList: {
      type: Array,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
      return {
        disabledDates: {
          to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        },
        value:"",
        promotion_name :"",
        promotion_logic_value: 0,
        promotion_logic_type: "percent",
        start_date: '',
        test_start: '',
        test_expired: '',
        test_schduler: '',
        expired_date: '',
        has_promotion: 0,
        checkBox: [],
        selectedId: '',
        offer_description:"ABC Nails. We're offering you a 10% off everything. See you soon! Call us: 888-888-8888.",
        counterDanger: false,
        type_submit: 1,
        scheduler_date: new Date(),
        max: 100,
        test: 0,
        settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
        text_area_length: 135,
        save_business_name: false,
        exp_active: true,
        opt_out_active: true,
      },
      configdateTimePicker: {
        enableTime: true,
        // dateFormat: 'Y-m-d 00:00:00'
        minDate: new Date(),
        dateFormat: 'Y-m-d H:i'
      },
      abc: false,
      business_name: "",
      email_subject: "",
      fileValid: true,
      phone_test: "",
      email_test: ""
      // StringHelper
    }
  },
  computed:{
    pro_start_date:{
      get(){return this.start_date},
      set(value){
        this.start_date = value
      }
    },
    pro_expired_date:{
      get(){return this.expired_date},
      set(value){
        this.expired_date = value
      }
    },
    pro_scheduler_date:{
      get(){return this.scheduler_date},
      set(value){
        this.scheduler_date = value
      }
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  watch: {
    addPromoConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.promotion_name = '';
        this.errors.clear();
        this.checkBox = [];
        this.abc = false;
        this.start_date = '';
        this.expired_date = '';
        this.promotion_logic_value = 0,
        this.promotion_logic_type = "percent",
        this.has_promotion = 0,
        this.business_name = (localStorage.getItem('promotion_business_name') != null) ? localStorage.getItem('promotion_business_name') : this.userInfo.name;
        this.offer_description = "We're offering you a 10% off everything. See you soon! Call us: 888-888-8888.";
        this.text_area_length = 135 - 14 - 22 - this.business_name.length;
        this.save_business_name = false;
        this.exp_active = true;
        this.opt_out_active = true;
        this.email_subject = "";
        this.phone_test = "";
        this.email_test = "";
        if(this.addPromoConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    active: function () {
      document.body.style.overflow = this.active ? 'hidden' : ''
    },
  },
  methods: {
    myMaskedNumber(str) {
      let result = "(";
      let number = ('' + str).replace(/[^\d]/g, '');
      result += number.substr(0, 3);
      if(result.length == 4) {
        result += ") ";
      }
      result += number.substr(3, 3);
      if(result.length == 9) {
        result += "-";
      }
      result += number.substr(6);
      this.phone_test = result;
      return result;
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
      } else {
        if(charCode >= 48 && charCode <= 57 && this.phone_test.length < 14) {
          this.myMaskedNumber(this.phone_test);
        }
        return true;
      }
    },
    changType(){
      if(this.promotion_logic_type == 'percent'){
        if(this.promotion_logic_value > 100){
          this.promotion_logic_value = 100;
          this.max = 100;
        }
      }
    },
    check: function(e) {
      if (e.checked) {
        console.log(e.value)
      }
    },
    selectId(e) {
      this.selectedId = e.id
      this.checkBox.push(this.selectedId)
    },
    addPromotion(){
      if (this.fileValid == false){
        this.$vs.notify({
              title:'Notification',
              text:'File size is too big. Its size cannot exceed 10 MiB.',
              color:'danger',
              position:'top-right'
          })
        return;
      }
      this.abc= true;
      if(this.promotion_logic_type == 'percent'){
        if(this.promotion_logic_value > 100){
          this.promotion_logic_value = 100;
        }
      }
      if (this.save_business_name == true){
        localStorage.setItem('promotion_business_name', this.business_name);
      }

      if(this.promotion_name != "" && this.start_date != "" && this.expired_date != ""){
        const obj = {
          name :this.promotion_name,
          logic_value: this.promotion_logic_value,
          logic_type: this.promotion_logic_type,
          start_date: moment(this.pro_start_date).format('YYYY-MM-DD 00:00:00'),
          expired_date: moment(this.pro_expired_date).format('YYYY-MM-DD 00:00:00'),
          has_promotion: this.has_promotion,
          groups: String(this.checkBox),
          content: this.offer_description,
          type_submit : this.type_submit,
          // scheduler_date: moment(this.scheduler_date).format('YYYY-MM-DD h:mm:ss'),
          scheduler_date: this.scheduler_date,
          page: this.currentPage,
          business_name: this.business_name,
          is_show_exp: (this.exp_active == true) ? 1 : 0,
          is_sent_opt_out: (this.opt_out_active == true) ? 1 : 0,
          email_subject: this.email_subject,
          'per-page': this.itemsPerPage,
          file: (this.$refs.myFiles && this.fileValid && this.$refs.myFiles.files[0] !== undefined) ? this.$refs.myFiles.files[0] : null
        }
        if(this.pro_start_date.getTime() > this.pro_expired_date.getTime()){
          this.$vs.notify({
              title:'Notification',
              text:'Expried date is less than start date',
              color:'danger',
              position:'top-right'
          })
          // if(this.pro_start_date.getTime() < this.scheduler_date.getTime()){
          //   this.$vs.notify({
          //       title:'Notification',
          //       text:'Start date is less than current date',
          //       color:'danger',
          //       position:'top-right'
          //   })
          // }
          // if(this.pro_expired_date.getTime() < this.scheduler_date.getTime()){
          //   this.$vs.notify({
          //       title:'Notification',
          //       text:'Expired date is less than current date',
          //       color:'danger',
          //       position:'top-right'
          //   })
          // }
        }
        else{
          this.closeAddPromo();
          this.$emit("AddPromotion", obj);
        }
      }
      this.$validator.validateAll();
    },
    show1(){
     document.getElementById('div1').style.display ='none';
    },
    show2(){
      document.getElementById('div1').style.display = 'block';
    },
    closeAddPromo() {
      this.$emit("CloseAddPromo");
    },
    inputBusinessName(){
      let temp = 0;
      if (this.exp_active == true) {
        temp -= 14;
      }
      if (this.opt_out_active == true){
        temp -= 22;
      }
      this.text_area_length = 135 - this.business_name.length + temp;
      if (this.offer_description.length > this.text_area_length){
        let cut = this.text_area_length - this.offer_description.length;
        this.offer_description = this.offer_description.slice(0, cut);
      }
    },
    inputDescription(value){
      // eslint-disable-next-line
      this.offer_description = value.replace(/[^\x00-\x7F]/g, "");
    },
    inputExpired(){
      this.exp_active = !this.exp_active;
      if (this.exp_active == true){
        this.text_area_length = this.text_area_length - 14;
      }else{
        this.text_area_length = this.text_area_length + 14;
      }
      if (this.offer_description.length > this.text_area_length){
        let cut = this.text_area_length - this.offer_description.length;
        this.offer_description = this.offer_description.slice(0, cut);
      }
      this.$forceUpdate();
    },

    inputOptOut(){
      this.opt_out_active = !this.opt_out_active;
      if (this.opt_out_active == true){
        this.text_area_length = this.text_area_length - 22;
      }else{
        this.text_area_length = this.text_area_length + 22;
      }
      if (this.offer_description.length > this.text_area_length){
        let cut = this.text_area_length - this.offer_description.length;
        this.offer_description = this.offer_description.slice(0, cut);
      }
      this.$forceUpdate();
    },
    validateFile(){
      this.fileValid = true;
      let fileSize = this.$refs.myFiles.files[0].size / 1024 / 1024;
      if (fileSize > 10) {
        this.fileValid = false;
      }
    },
    sendTest(type){
      let obj = {
        email_test: this.email_test,
        phone_test: this.phone_test,
        content: this.offer_description,
        exp_date: moment(this.pro_expired_date).format('YYYY-MM-DD 00:00:00'),
        date_start: moment(this.pro_start_date).format('YYYY-MM-DD 00:00:00'),
        email_subject: this.email_subject,
        business_name: this.business_name,
        is_show_exp: (this.exp_active == true) ? 1 : 0,
        is_sent_opt_out: (this.opt_out_active == true) ? 1 : 0,
        type: type,
        campaign_name: this.promotion_name
      }
      this.$store.dispatch("promoList/SEND_TEST", obj).then(() => {
        this.$vs.notify({
              title:'Success',
              text:'Send test ' + type.toUpperCase() + ' success!',
              color:'success',
              position:'top-right'
          })
      }).catch(e=>{
          this.$vs.notify({
              title:'Error',
              text:'Invalid data to send test SMS/Email',
              color:'danger',
              position:'top-right'
          });
          console.log(e);
          });
    }
  }
};
</script>
